import { render, staticRenderFns } from "./CogCalculatorForm.vue?vue&type=template&id=2bed6d74&scoped=true"
import script from "./CogCalculatorForm.vue?vue&type=script&lang=js"
export * from "./CogCalculatorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed6d74",
  null
  
)

export default component.exports